import apiClient from '../services/apiClient';

// Shared CSV download helper (backend/src/lib/csv.js is the server half).
// Fetches the endpoint as a blob through the authenticated apiClient (so the
// JWT bearer header is attached the same as any other API call — a plain
// <a href> can't carry it) and hands the browser a synthetic click to save it
// under the given filename.
export async function downloadCsv(path: string, filename: string): Promise<void> {
  const res = await apiClient.get(path, { responseType: 'blob' });
  const blob = new Blob([res.data], { type: 'text/csv;charset=utf-8' });
  downloadBlobFile(blob, filename);
}

// Same synthetic-click trick as downloadCsv above, factored out for callers
// that already hold an in-memory Blob (e.g. features/attendance/exportXlsx.ts,
// which builds the .xlsx client-side — there is no network response to fetch
// as a blob in the first place).
export function downloadBlobFile(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  try {
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
  } finally {
    URL.revokeObjectURL(url);
  }
}
